import { Fragment, useState } from "react";
import { sentenceCase } from "change-case-all";
import { Grid, Typography } from "@mui/material";

import { Paper } from "../../../components";
import ShowAudienceSizeDialog from "./ShowAudienceSize";
import { ActiveTextEighteen, colors } from "../../css components/Style";

export default function AdminCampaignStatus({ audienceSize, formikProps }) {
  const [showAudSize, setShowAudSize] = useState();
  return (
    <Fragment>
      {!!formikProps.values.campaignID && (
        <Paper style={{ background: colors.hoverBlue, padding: "15px" }}>
          {!!(
            audienceSize?.values?.audience_params ||
            audienceSize?.values?.audience_size
          ) &&
            formikProps.values.permissionSettings?.consumer_audience_view && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.green }}>
                  Your audience size is ready ! &nbsp;{" "}
                </ActiveTextEighteen>
                <ActiveTextEighteen
                  color={colors.sprintexBlue}
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowAudSize(true)}
                >
                  View
                </ActiveTextEighteen>
              </Grid>
            )}

          {formikProps.values.campaignStatus === "REQUESTED" &&
            !formikProps.values?.isPendingSizing &&
            !(
              audienceSize?.values?.audience_params ||
              audienceSize?.values.audience_size
            ) && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.warning }}>
                  Your campaign request has been raised and is expected to be
                  ready within 24 to 72 hours.
                </ActiveTextEighteen>
              </Grid>
            )}

          {formikProps.values.campaignStatus === "REQUESTED" &&
            formikProps.values?.isPendingSizing &&
            !(
              audienceSize?.values?.audience_params ||
              audienceSize?.values?.audience_size
            ) && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.warning }}>
                  The process is taking longer than expected. Please contact the
                  admin.
                </ActiveTextEighteen>
              </Grid>
            )}

          {!!(
            audienceSize?.values?.audience_params ||
            audienceSize?.values?.audience_size
          ) &&
            formikProps.values.isCampaignLive &&
            formikProps.values.campaignStatus !== "ACTIVE" && (
              <Grid size={12} textAlign={"center"} display={"flex"}>
                <ActiveTextEighteen style={{ color: colors.sprintexBlue }}>
                  Request sent for making campaign live.
                </ActiveTextEighteen>
              </Grid>
            )}

          {!(
            audienceSize?.values?.audience_params ||
            audienceSize?.values?.audience_size
          ) && (
            <Grid size={12}>
              <Typography variant="h5" style={{ color: colorPicker() }}>
                {sentenceCase(formikProps.values.campaignStatus)}
              </Typography>
            </Grid>
          )}

          {(audienceSize?.values?.audience_params ||
            audienceSize?.values?.audience_size) &&
            formikProps.values.status !== "CREATED" &&
            !formikProps.values.publishedCampaign && (
              <Grid size={12}>
                <Typography variant="h5" style={{ color: colorPicker() }}>
                  {sentenceCase(formikProps.values.campaignStatus)}
                </Typography>
              </Grid>
            )}

          {formikProps.values.status === "CREATED" &&
            !(
              audienceSize?.values?.audience_params ||
              audienceSize?.values?.audience_size
            ) && (
              <Grid size={12}>
                <Typography variant="h6" color={colors.warning}>
                  The request has been raised and is expected to be ready within
                  24 to 72 hours.
                </Typography>
              </Grid>
            )}
        </Paper>
      )}

      <ShowAudienceSizeDialog
        formikProps={formikProps}
        audienceSize={audienceSize}
        showAudSize={showAudSize}
        setShowAudSize={setShowAudSize}
      />
    </Fragment>
  );

  function colorPicker() {
    let color;

    if (
      formikProps.values.campaignStatus === "REQUESTED" ||
      formikProps.values.campaignStatus === "CREATED"
    ) {
      color = colors.warning;
    }

    if (
      formikProps.values.campaignStatus === "OFFER_ACCEPTED" ||
      formikProps.values.campaignStatus === "ACTIVE"
    ) {
      color = colors.success;
    }

    if (formikProps.values.campaignStatus === "INITIATED") {
      color = colors.sprintexBlue;
    }

    if (
      formikProps.values.campaignStatuss === "REJECTED" ||
      formikProps.values.campaignStatus === "Expired" ||
      formikProps.values.campaignStatus === "FAILED"
    ) {
      color = colors.error;
    }

    if (
      formikProps.values.campaignStatus === "READY" ||
      formikProps.values.campaignStatus === "SIZE_READY"
    ) {
      color = colors.success;
    }

    return color;
  }
}
